module.exports = __webpack_public_path__ + "pc/img/modal_19.32380347.png";